import Decimal from 'decimal.js';
import { EPaymentMethodDisplayName, EPaymentProvider } from '../../contracts';

export interface PaypalSubmitParams {
  email: string;
  paymentNonce: string;
  paymentMethodId: string;
  paymentMethodDetails: any;
  paymentProvider: PaypalPaymentProvider;
}

export type PaypalPaymentProvider = EPaymentProvider.braintree | EPaymentProvider.paypal;

export function createPaypalFinalizePaymentBody({
  email,
  paymentNonce,
  paymentMethodId,
  paymentProvider,
  paymentMethodDetails,
}: PaypalSubmitParams) {
  return {
    paymentProvider,
    receipt_email: email,
    paymentMethodDisplayName: EPaymentMethodDisplayName.paypal,
    paymentMethodId,
    params: {
      paymentNonce,
      paymentMethodDetails,
    },
  };
}

export const getPaypalAmount = (num: number, multiplier: number) => {
  return multiplier === 1 ? num.toString() : new Decimal(num).div(multiplier).toString();
};
